import React from 'react';
import {
  hasOmdAttributeData,
  hasOmdComplianceData,
  hasOmdDimensionsData,
  hasOmdSparePartData,
  type OmdProduct,
} from '../../../utils/omdProductView';
import type { OmdPanelSettings } from '../../../utils/omdPanelSettings';
import {
  OmdComplianceSection,
  OmdDimensionsCards,
  OmdSparePartList,
} from '../shared/OmdComplianceSection';
import { OmdEmptyHint } from '../shared/OmdEmptyHint';
import { OmdEtimTable } from '../shared/OmdEtimTable';
import { OmdRawJsonSection } from '../shared/OmdRawJsonSection';
import { OmdSection } from '../shared/OmdSection';

type OmdTechnikTabProps = {
  product: OmdProduct;
  rawProduct: unknown;
  settings: OmdPanelSettings;
  hideRawJson?: boolean;
};

export function OmdTechnikTab({ product, rawProduct, settings, hideRawJson }: OmdTechnikTabProps) {
  const showAttributes = product.additional?.attribute != null;
  const showLogistics = product.logistics != null;
  const showSpareParts = product.sparepartlists != null;
  const hasAnySection = showAttributes || showLogistics || showSpareParts;

  if (!hasAnySection) {
    return <p className="text-sm text-app-text-subtle">Keine technischen Merkmale verfügbar.</p>;
  }

  return (
    <div className="space-y-4">
      {showAttributes && (
        <OmdSection title="Technische Merkmale" settings={settings}>
          {hasOmdAttributeData(product) ? <OmdEtimTable product={product} /> : <OmdEmptyHint />}
        </OmdSection>
      )}

      {showLogistics && (
        <OmdSection title="Maße & Gewicht" settings={settings}>
          {hasOmdDimensionsData(product.logistics) ? (
            <OmdDimensionsCards logistics={product.logistics} />
          ) : (
            <OmdEmptyHint />
          )}
        </OmdSection>
      )}

      {showLogistics && (
        <OmdSection title="Umwelt & Konformität" settings={settings}>
          {hasOmdComplianceData(product) ? (
            <OmdComplianceSection product={product} settings={settings} />
          ) : (
            <OmdEmptyHint />
          )}
        </OmdSection>
      )}

      {showSpareParts && (
        <OmdSection title="Ersatzteilliste" settings={settings}>
          {hasOmdSparePartData(product) ? (
            <OmdSparePartList product={product} />
          ) : (
            <OmdEmptyHint />
          )}
        </OmdSection>
      )}

      {!hideRawJson && <OmdRawJsonSection product={rawProduct} />}
    </div>
  );
}
